import * as React from 'react'

import TopVisualUrl from './assets/top_visual.jpg'
import * as styles from './ImageAsset.css'

export enum ImageAssetType {
  TOP_VISUAL = 'top visual'
}

interface ImageAssetProps {
  type: ImageAssetType
}

const ImageAsset: React.FunctionComponent<ImageAssetProps> = ({ type }) => {
  const src = TopVisualUrl
  return <img className={styles.image} src={src} alt={type} />
}

export default ImageAsset
